import { CRITICAL_COLLATERAL_RATIO, Decimal, MINIMUM_COLLATERAL_RATIO } from '@liquity/lib-base'

// NOTE: Mytroveで利用しても文字色が変わらない
export const getCollateralRatioStyle = (collateralRatio: Decimal | undefined, isRecoveryMode?: boolean):string => {
  if (!collateralRatio) return ""

  if (isRecoveryMode) {
    return collateralRatio.lt(CRITICAL_COLLATERAL_RATIO)
      ? "text-color-danger"
      : ""
  }

  return collateralRatio.lt(MINIMUM_COLLATERAL_RATIO)
    ? "text-color-danger"
    : collateralRatio.gte(MINIMUM_COLLATERAL_RATIO) && collateralRatio.lt(CRITICAL_COLLATERAL_RATIO)
      ? "text-color-warning"
      : ""
}

export const getTotalCollateralRatioStyle = (totalCollateralRatio: Decimal):string => {
  return totalCollateralRatio.lt(CRITICAL_COLLATERAL_RATIO)
    ? "text-color-danger"
    : ""
}
